<template>
  <div class="app">
    <!-- <div class="fullscreen-fix"></div> -->
    <div id="app" class="initial">
      <div class="error" v-if="error">
        <span v-lang.compatibility></span>
        <div class="error-msg">
          {{error.msg}}
        </div>
      </div>
      <breadcrumbs
      v-show="showBreadcrumbs"
      class="hide-cursor"
      ref="breadcrumbs"
      ></breadcrumbs>
      <router-view></router-view>
      <div class="orientation-message">
        <div class="v-center">
          <img src="static/img/rotate.svg" alt="">
          <span v-lang.turn></span>
        </div>
      </div>
      <div class="width-message">
        <div class="v-center">
          <img src="static/img/AR_logo_black.svg" alt="">
          <p v-lang.devicemessage></p>
        </div>
      </div>
      <div class="hint" v-if="showHint && touch && hint" >
        <div class="hint-text">
          {{getHintText(hint.text)}}
        </div>
        <img v-bind:src="hint.image" alt="">
      </div>
      <div class="click-catcher"
           v-if="showHint && touch && hint"
           @click="hideHint"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      showBreadcrumbs: false,
      showHint: false,
      hintIndex: 0,
      touch: false,
      hintCategory: null,
      chapterVisited: false,
      error: null
    }
  },
  mounted () {
    this.$bus.$on('enter-site', this.onEnterSite.bind(this))
    this.$bus.$on('show-intro', () => { this.showBreadcrumbs = false })
    this.$bus.$on('chapter-enabled', this.onChapterEnabled.bind(this))
    this.$bus.$on('webglerror', this.onWebglError.bind(this))
    this.$refs.breadcrumbs.$el.addEventListener('mouseenter', this.onMouseOverBreadcrumbs.bind(this, true))
    this.$refs.breadcrumbs.$el.addEventListener('mouseleave', this.onMouseOverBreadcrumbs.bind(this, false))
    window.addEventListener('touchend', function onFirstTouch () {
      document.body.classList.add('user-is-touching')
      this.$bus.$emit('USER_IS_TOUCHING', true)
      window.removeEventListener('touchend', onFirstTouch, false)
      this.touch = true
    }.bind(this), false)
  },
  methods: {
    onEnterSite () {
      this.showBreadcrumbs = true
      this.showHints('rooftop')
    },
    onMouseOverBreadcrumbs (over) {
      this.$bus.$emit('hide-cursors', over)
    },
    onChapterEnabled () {
      if (!this.chapterVisited) {
        this.showHints('chapter')
        this.chapterVisited = true
      }
    },
    onWebglError (error) {
      this.error = error
    },
    showHints (hintCategory) {
      this.hint = {
        text: hintCategory,
        image: 'static/img/hint-' + hintCategory + '.svg'
      }
      this.showHint = true
    },
    incrementHint () {
      if (++this.hintIndex >= this.hints.length) {
        this.showHint = false
        this.hintIndex = 0
      }
    },
    hideHint () {
      this.showHint = false
    },
    getHintText (text) {
      return this.translate('hints.' + text)
    }
  }
}
</script>

<style lang="scss">
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: white;
}
.orientation-message, .width-message{
  display: none;
  position: absolute;
}
.width-message{
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: white;
  z-index: 20001;
}
.orientation-message{
  border: 4px solid black;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  z-index: 20000;
  img {
    width: 250px;
    display: block;
    margin: 24px auto;
  }
  span {
    margin: 16px 48px;
    padding: 16px 0;
    font-size: 32px;
    display: block;
  }
}
@media screen and (orientation: portrait) and (min-height: 641px){
  .orientation-message {
    display: block;
  }
}

@media screen and (orientation: portrait) and (max-height: 640px) {
  .width-message {
    display: block;
    img {
      max-width: 50%;
      display: block;
      margin: 0 auto;
    }
  }
}
@media(max-width: 640px) and (orientation: landscape) {
  .width-message {
    display: block;
    img {
      max-width: 50%;
      display: block;
      margin: 0 auto;
    }
  }
}
.fullscreen-fix {
  height: 200vh;
}
.hint {
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 4;
  color: black;
  max-width: 100%;
  border: 4px solid black;
  padding: 32px 48px;
}
.hint-text {
  margin: 0 auto 32px;
  font-size: 24px;
  font-weight: 700;
}
.hint img {
  max-height: 150px;
}
.click-catcher {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.error {
  padding: 32px;
  font-size: 24px;
  background: white;
  margin: 32px;
}
#app.initial {
  position: static;
  height: 120vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue